<template>
  <div class="flex items-center shadow-lg p-4 header">
    <!-- <img class="rounded-circle user-avatar" :src="require(`@/assets/images/alex/${alexImage}`)" alt="" srcset="" /> -->
    <div class="">
      <div class="font-semibold flex text-xl">Validation</div>
      <!-- <div class="flex items-center small font-light">
        <div class="rounded-lg online-indicatior bg-success"></div>
        Always Active
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    alexImage() {
      return this.$store.state.users.orgAlexImage;
    },
    alexName() {
      return this.$store.state.bot.alexName;
    },
  },
};
</script>
